export default function fetchData(url, callback) {
  console.debug('fetch new data for', url);
  fetch(url)
    .then((response) => {
      if (!response.ok) throw new Error('Network response was not ok');
      return response.json();
    })
    .then((data) => callback(data))
    .catch((error) => {
      // handle any errors here
      console.error(error);
    });
}
